var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.752,
    height: 40.819,
    viewBox: "0 0 44.752 40.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M348.311,135a1.311,1.311,0,1,0,1.311,1.311A1.313,1.313,0,0,0,348.311,135Zm0,0",
    transform: "translate(-316.67 -123.2)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_206",
    "data-name": "Path 206",
    d: "M238.222,14.422V11.8h-2.7a10.406,10.406,0,0,0-.739-2.757l2.342-1.352L235.81,5.42l-2.346,1.354a10.589,10.589,0,0,0-2.016-2.016L232.8,2.412,230.531,1.1l-1.352,2.342a10.4,10.4,0,0,0-2.757-.739V0H223.8V2.7a10.4,10.4,0,0,0-2.756.739L219.691,1.1,217.42,2.412l1.354,2.346a10.6,10.6,0,0,0-2.017,2.017L214.412,5.42,213.1,7.691l2.342,1.352A10.4,10.4,0,0,0,214.7,11.8H212v2.622h2.7a10.4,10.4,0,0,0,.739,2.756L213.1,18.531l1.311,2.271,2.346-1.355a10.582,10.582,0,0,0,2.017,2.017L217.42,23.81l2.271,1.311,1.352-2.343a10.405,10.405,0,0,0,2.757.74v2.7h2.622v-2.7a10.4,10.4,0,0,0,2.756-.739l1.352,2.342L232.8,23.81l-1.355-2.346a10.581,10.581,0,0,0,2.017-2.017L235.81,20.8l1.311-2.271-2.342-1.352a10.4,10.4,0,0,0,.739-2.756h2.7Zm-13.111,2.622a3.933,3.933,0,1,1,3.933-3.933A3.938,3.938,0,0,1,225.111,17.044Zm0,0",
    transform: "translate(-193.47)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_207",
    "data-name": "Path 207",
    d: "M39.006,207.89l3.263-2.6A15.8,15.8,0,0,1,33.752,195H19.007l16.187,12.89a3.045,3.045,0,0,0,3.811,0Zm0,0",
    transform: "translate(-17.346 -177.956)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_208",
    "data-name": "Path 208",
    d: "M0,218.215v19.718l12.38-9.86Zm0,0",
    transform: "translate(0 -199.142)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_209",
    "data-name": "Path 209",
    d: "M311.065,307.48l-.7.556,12.38,9.853V305.836a15.725,15.725,0,0,1-11.681,1.644Zm0,0",
    transform: "translate(-283.238 -279.104)",
    fill: "#1a8fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_210",
    "data-name": "Path 210",
    d: "M40.656,351.554a5.655,5.655,0,0,1-7.078,0l-1.73-1.378L19.027,360.388h36.19l-12.83-10.211Zm0,0",
    transform: "translate(-17.363 -319.568)",
    fill: "#1a8fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailConfig);
export default __webpack_public_path__ + "static/media/email_config.2fc09022137f3d236eb8a4ff7615fa32.svg";
export { ForwardRef as ReactComponent };